(function () {
  var box = document.querySelector("[data-wwa-form]");
  if (!box) return;
  var form = box.closest("form") || box;
  var body = box.querySelector("[data-wwa-body]");
  var type = box.getAttribute("data-wwa-type") || "hospitals";

  form.addEventListener("submit", function () {
    var labels = {
      hospitals: "Hospital network application",
      referral: "Referral partner application",
      travel: "Travel & ground services application"
    };
    var lines = [labels[type] || "Partnership application"];
    box.querySelectorAll("[data-wwa-line]").forEach(function (el) {
      if (el.disabled || el.closest("[hidden]")) return;
      var label = el.getAttribute("data-wwa-line") || el.name || "";
      var value = String(el.value || "").trim();
      if (value) lines.push(label + ": " + value);
    });
    if (body) body.value = lines.join("\n");
  });
})();
